export { default } from '../../../../../../containers/product/index';

